module.exports = __webpack_public_path__ + "img/btn-ota-no.d9fe60a0.png";